import axios from 'axios';
import AxiosError from 'axios-error';
import urlJoin from 'url-join';
import Cookies from 'js-cookie';


axios.defaults.headers.post['Content-Type'] = 'application/json';


export default class DpitNotices {

	constructor(config) {
		if (config.dpDebugEn) console.log('DpitNotices');
		this.config = config;
		axios.defaults.baseURL = this.config.siteUrl;
		this.wpDpApiCfg = {
			baseURL: urlJoin(this.config.restApiUrl, 'dpintrotours/v1/'),
			headers: { 'X-WP-Nonce': this.config.nonces.wp_rest }
		};
		this.activateA4R();
		this.activateCreateFirstTourDismiss();
	}

	closeNoticeAndSaveCookieFlag = (target, cookieVal = '1', expiresDays = 30) => {
		const notice = $(target).closest('.dpit-notice');
		if (notice && notice.length) {
			const id = notice.attr('id');
			notice.remove();
			if (id) {
				Cookies.set(id, cookieVal, { expires: expiresDays });
			}
		}
	};


	updateUserSetting = (key, value) => {
		// adjust user settings in db
		axios.post('/set-user-data', { key: key, value: value }, this.wpDpApiCfg)
			.catch(error => {
				console.log(new AxiosError(error));
			});
	};

	dismissCreateFirstNotice = () => {
		// adjust user settings in db
		axios.post('/dismiss-create-first-notice', {}, this.wpDpApiCfg)
			.catch(error => {
				console.log(new AxiosError(error));
			});
	};


	sendFeedbackToDeepPresentationCom = (type) => {

		axios.post(urlJoin(this.config.ratingFeedbackLink, type))
			.then(() => {

			})
			.catch(error => {
				console.log(new AxiosError(error));
			});
	};

	activateCreateFirstTourDismiss = () => {
		$('#dpit-notice-create-first-tour button.notice-dismiss').on('click', () => {
			this.dismissCreateFirstNotice();
		});
	};

	activateA4R = () => {
		$('#a4r-link-already-did').on('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			this.closeNoticeAndSaveCookieFlag(event.target, '1', 90);
			this.sendFeedbackToDeepPresentationCom('already-did');
		});

		$('#a4r-link-no-good').on('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			this.closeNoticeAndSaveCookieFlag(event.target, '1', 90);
			this.sendFeedbackToDeepPresentationCom('no-good');
		});

		$('#a4r-link-OK').on('click', (event) => {
			this.closeNoticeAndSaveCookieFlag(event.target, '1', 120);
			this.sendFeedbackToDeepPresentationCom('ok');
		});
	};
}